import { Box, CheckBox, ModBox, Text } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { useStores } from '../../../data/store'
import { PAYMENT_MODE_SUBTYPES } from '../../../utils/constants'
import { WalletContainer } from './WalletContainer'

interface WalletProps {
  type: string
  isEdit?: boolean
}
const Wallet = ({ type, isEdit }: WalletProps) => {
  const { updateAllSelection, isAllWalletSelected } = useStores((root) => ({
    updateAllSelection: root.updateAllSelection,
    isAllWalletSelected: root.onboarding.isAllWalletSelected,
    walletSelectedLength: root.walletSelectedLength(),
  }))
  const [showAllWallets, setShowAllWallets] = useState(isAllWalletSelected)

  useEffect(() => {
    setShowAllWallets(isAllWalletSelected)
  }, [isAllWalletSelected])

  const onChange = (isChecked: string) => {
    setShowAllWallets(isChecked === 'true')
    updateAllSelection(isChecked === 'true', PAYMENT_MODE_SUBTYPES.WALLET)
  }

  const setIsAllChecked = (isChecked: boolean) => {
    setShowAllWallets(isChecked)
  }
  return (
    <Box f={1} overflow={'auto'} ph={40} pv={40} minHeight={600}>
      <Text title={'Select wallets to provide access'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
      <ModBox
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        marginVertical={24}
        height={32}>
        <CheckBox
          textStyle={'body'}
          onChange={onChange}
          textLabel={'Select all Wallets'}
          checked={showAllWallets}
          iconSize={16}
          fontSize={12}
          disabled={!isEdit}
          color={isEdit ? 'BLUE_SHADE_PRIMARY' : 'DARK_GREY'}
        />
      </ModBox>
      <WalletContainer isAllChecked={showAllWallets} isEdit={isEdit} setIsAllChecked={setIsAllChecked} />
    </Box>
  )
}
export { Wallet }
